import React, { useEffect, useState } from 'react';
import { STRIPE_PUBLISHABLE_KEY } from '../utils/shopData';

/* Stripe's buy button is a web component. Its script is only pulled in when a
   product page actually renders one, so the rest of the site never loads
   Stripe at all. */

const SRC = 'https://js.stripe.com/v3/buy-button.js';
let loading = null;

function loadStripe() {
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${SRC}"]`)) { resolve(); return; }
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return loading;
}

export default function BuyButton({ buyButtonId, soldOut }) {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);

  const usable = Boolean(buyButtonId && STRIPE_PUBLISHABLE_KEY && !soldOut);

  useEffect(() => {
    if (!usable) return;
    let live = true;
    loadStripe().then(() => live && setReady(true)).catch(() => live && setFailed(true));
    return () => { live = false; };
  }, [usable]);

  if (soldOut) {
    return <div className="shop-status caption-text">Sold out</div>;
  }

  // the work can go up before the till does
  if (!buyButtonId || !STRIPE_PUBLISHABLE_KEY) {
    return <div className="shop-status caption-text">Not for sale yet</div>;
  }

  if (failed) {
    return (
      <div className="shop-status caption-text">
        Checkout unavailable. Email <a href="mailto:lukeabcstudio@gmail.com">lukeabcstudio@gmail.com</a>.
      </div>
    );
  }

  if (!ready) return <div className="shop-status caption-text">Loading…</div>;

  return (
    <div className="shop-buy">
      <stripe-buy-button
        buy-button-id={buyButtonId}
        publishable-key={STRIPE_PUBLISHABLE_KEY}
      />
    </div>
  );
}
